import { ISignedDocumentResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { SignedDocumentStatus } from "@wingspanhq/signed-documents/dist/lib/interfaces/signedDocument";
import { WSEmptyStateProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSEmptyState/WSEmptyState";
import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";

export const payerSignatureRenderCardDescription = (
  requirement: IRequirementResponse,
  signedDocument?: ISignedDocumentResponse
) => {
  const signedDocumentDescriptions: Record<
    SignedDocumentStatus,
    WSEmptyStateProps
  > = {
    [SignedDocumentStatus.New]: {
      type: "documents",
      title: "Document preparation in progress",
      description:
        "The file is currently being prepared for signature and will be available shortly."
    },
    [SignedDocumentStatus.Sent]: {
      type: "documents",
      title: "Document awaiting signature",
      description:
        "Please review and sign the document at your earliest convenience."
    },
    [SignedDocumentStatus.Pending]: {
      type: "documents",
      title: "Document pending countersignature",
      description:
        "The document has been signed by you and is awaiting countersignature from the client."
    },
    [SignedDocumentStatus.Complete]: {
      type: "done",
      title: "Your e-signature document is complete",
      description: "The fully executed document is available for download."
    }
  };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus: signedDocument?.status || SignedDocumentStatus.New,
    documentStatuses: signedDocumentDescriptions,
    pendingApprovalStatus: {
      type: "documents",
      title: "Document pending approval",
      description:
        "All signatures have been collected. The requirement now requires client approval."
    },
    approvedStatus: null,
    rejectedStatus: {
      type: "documents",
      title: "Document was rejected",
      description:
        "The requirement was rejected and may affect your eligibility for related engagements."
    }
  });
};
